import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import {IntlMessage, IntlMessageValue, UniButton, UniForm} from '../../../../../../@WUM/core/Elements';
import UniSelect from '../../../../../../@WUM/core/Elements/Form/Elements/Select';
import Card from "react-bootstrap/Card";

interface CreateTicketOffcanvasProps {
    show: boolean;
    validated: boolean;
    handleClose: () => void;
    createNewMessage: (event: React.FormEvent<HTMLFormElement>) => void;
    Store: any;
}

export default function CreateTicketOffcanvas({
                                                  show,
                                                  validated,
                                                  handleClose,
                                                  createNewMessage,
                                                  Store,
                                              }: CreateTicketOffcanvasProps): JSX.Element {
    return (
        <Offcanvas show={show} onHide={handleClose} placement={'end'}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    {IntlMessageValue('de', 'support.ticket.offcanvas.title', Store)}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <UniForm validated={validated} Submit={(event) => createNewMessage(event)}>
                    <UniForm.InputGroup>
                        <UniForm.InputGroupText
                            text={IntlMessageValue('de', 'support.ticket.offcanvas.subject.label', Store)}
                        />
                        <UniForm.FormControl
                            name={'subject'}
                            required={true}
                            maxLength={30}
                        />
                        <UniForm.ControlFeedback
                            text={IntlMessageValue('de', 'support.ticket.offcanvas.subject.feedback', Store)}
                        />
                    </UniForm.InputGroup>

                    <UniForm.FormGroup>
                        <UniForm.Label
                            text={IntlMessageValue('de', 'support.ticket.offcanvas.type.label', Store)}
                        />
                        <UniSelect
                            name={'type'}
                            items={[
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.general', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.general', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.question', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.question', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.security_issue', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.security_issue', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.bug', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.bug', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.compatibility', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.compatibility', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.permissions', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.permissions', Store),
                                },
                                {
                                    value: IntlMessageValue('de', 'support.ticket.offcanvas.type.contract', Store),
                                    text: IntlMessageValue('de', 'support.ticket.offcanvas.type.contract', Store),
                                },
                            ]}
                        />
                    </UniForm.FormGroup>

                    <UniForm.FormGroup>
                        <UniForm.Label
                            text={IntlMessageValue('de', 'support.ticket.offcanvas.message.label', Store)}
                        />
                        <UniForm.FormControl
                            name={'message'}
                            required={true}
                            rows={3}
                            as="textarea"
                        />
                        <UniForm.ControlFeedback
                            text={IntlMessageValue('de', 'support.ticket.offcanvas.message.feedback', Store)}
                        />
                    </UniForm.FormGroup>

                    <UniButton type={'submit'}>
                        {IntlMessageValue('de', 'support.ticket.offcanvas.submit', Store)}
                    </UniButton>

                    <p className={'mt-2'}>
                        <Card className={"mx-auto"} style={{
                            background:
                                "#f8f9fa"
                        }}>
                            <Card.Body>
                                <IntlMessage
                                    messageId="support.ticket.offcanvas.forum.text"
                                    renderAsHTML={true}
                                    Store={Store}
                                    allowExternalLinks={true}
                                />
                            </Card.Body>
                        </Card>
                    </p>
                </UniForm>
            </Offcanvas.Body>
        </Offcanvas>
    );
}